import React from 'react'
import styled from 'styled-components'

interface FloatProps {
  top?: number | string
  bottom?: number | string
  left?: number | string
  right?: number | string
  children: any
  ww?: number | string
  w?: number | string
  h?: number | string
  float?: boolean
  zIndex?: boolean
  position?: 'relative' | 'absolute'
}

const Float: React.FC<FloatProps> = ({ zIndex = true, children, ...props }) => {
  return (
    <StyledFloat zIndex={zIndex}>
      <StyledInner {...props}>{children}</StyledInner>
    </StyledFloat>
  )
}

export default Float

const StyledFloat = styled.div<FloatProps>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  ${(p) => p.zIndex && 'z-index: 20;'}
`

const StyledInner = styled.div<FloatProps>`
  position: ${(p) => (p.position ? p.position : 'relative')};
  top: 0;
  left: 0;
  top: ${(p) => p.top && (typeof p.top === 'number' ? `${p.top}px` : p.top)};
  left: ${(p) => p.left && (typeof p.left === 'number' ? `${p.left}px` : p.left)};
  right: ${(p) => p.right && (typeof p.right === 'number' ? `${p.right}px` : p.right)};
  bottom: ${(p) => p.bottom && (typeof p.bottom === 'number' ? `${p.bottom}px` : p.bottom)};
  ${(p) => (p.w && typeof p.w === 'number' ? `max-width: ${p.w}px` : `max-width: ${p.w}`)};
  ${(p) => (p.w && typeof p.ww === 'number' ? `width: ${p.ww}px` : `width: ${p.ww}`)};
  ${(p) => (p.h && typeof p.h === 'number' ? `height: ${p.h}px` : `height: ${p.h}`)};
  ${(p) => p.float && 'position:absolute !important;'}
`
